import { useQuery } from "@tanstack/react-query";
import { USERAXIOS } from "../../api";
import { JobAvailability } from "../../types/resume";

interface JobAvailabilitiesResponse {
  data: JobAvailability[];
}

export const useJobAvailabilities = () => {
  return useQuery({
    queryKey: ["jobAvailabilities"],
    queryFn: async (): Promise<JobAvailability[]> => {
      const response = await USERAXIOS.get<JobAvailabilitiesResponse>(
        "/job_availabilities"
      );
      return response.data.data;
    },
  });
};
